import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Default_LatLng, ExplorerContext } from '../../application/config';
import { useAppSelector } from '../../state/hooks';
import { RootState } from '../../state/store';
import { LatLng } from 'leaflet';
import { Marker } from 'react-leaflet';
import { iconUser } from '../MapComponents/mapIcons';

export default function LocationMarker() {
	const AppData = useContext(ExplorerContext);
	const defaultCenter = AppData.boundary.getCenter();
	const currentLat = useAppSelector(
		(state: RootState) => state.location.latitude,
	);
	const currentLng = useAppSelector(
		(state: RootState) => state.location.longitude,
	);
	const currentAccuracy = useAppSelector(
		(state: RootState) => state.location.accuracy,
	);
	const current_location = useMemo(
		() => new LatLng(currentLat, currentLng),
		[currentLat, currentLng],
	);
	const [position, setPosition] = useState<LatLng>(defaultCenter);
	const hasValidLocation =
		currentAccuracy > 0 ||
		currentLat !== Default_LatLng.lat ||
		currentLng !== Default_LatLng.lng;

	useEffect(() => {
		if (hasValidLocation) {
			setPosition(current_location);
		}
	}, [current_location, hasValidLocation]);

	return !hasValidLocation || position === null ? null : (
		<Marker position={position} icon={iconUser} />
	);
}
